export const formatCurrency = (value: string): string => {
  if (!value) return '';
  const numbers = value.replace(/\D/g, '');
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(Number(numbers) / 100);
};